<div class="fpc_message_container margin-3" [innerHTML]="content"></div>
